import { useMutation } from '@tanstack/react-query';

import { getSMPBackendAPIAdmin } from '@/proxy';

function acceptPublishedBooking(id: string) {
  return getSMPBackendAPIAdmin().resourceBookingsControllerAcceptPublishedServiceBookingV1(id);
}

export function useAcceptPublishedBooking() {
  return useMutation({ mutationFn: acceptPublishedBooking });
}
